/**
 * 디버깅 로그 유틸리티
 * 개발 환경에서만 로그를 출력합니다.
 */

const isDevelopment = process.env.NODE_ENV === 'development'

export const debugLogger = {
  /**
   * 일반 로그 출력
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args)
    }
  },

  /**
   * 정보 로그 출력
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args)
    }
  },

  /**
   * 경고 로그 출력
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args)
    }
  },

  /**
   * 에러 로그 출력
   */
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error('[ERROR]', ...args)
    }
  },
}

export default debugLogger
